/*****************************************************************************************/
// CLOSE CART DRAWER
document.addEventListener("liquid-ajax-cart:request-end", (event) => {
  const { requestState } = event.detail;
  if (requestState.requestType === "add" && requestState.responseData?.ok) {
    document.querySelector("body").classList.add("js-ajax-cart-open");
  }
});

function runWhenInit() {
  console.log("The current cart state is: ", window.liquidAjaxCart.cart);
}

if (window.liquidAjaxCart?.init) {
  // if Liquid Ajax Cart is already initialized
  runWhenInit();
} else {
  // wait for Liquid Ajax Cart to be initialized
  document.addEventListener("liquid-ajax-cart:init", runWhenInit);
}

/*****************************************************************************************/
// CART UPSELL - Using Event Delegation to Ensure Buttons Stay Clickable
function formatToGermanMoney(price) {
  const adjustedPrice = price / 100;
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(adjustedPrice);
}
document.addEventListener("click", function (event) {
  if (event.target.classList.contains("openUpsell")) {
    event.preventDefault();
    handleUpsellClick(event.target);
  }

  // Close modal when clicking the close button
  if (event.target.classList.contains("MyCartUpsells_CloseModal")) {
    closeUpsellModal();
  }

  // Add upsell product to cart
  if (event.target.classList.contains("MyCartUpsells_AddToCart")) {
    event.preventDefault();
    addUpsellToCart();
  }
});

function handleUpsellClick(button) {
  // Fetch data from button attributes
  const upsellId = button.dataset.upsellId;
  const imageUrl = button.dataset.imageUrl;
  const title = button.dataset.title;
  const firstPrice = button.dataset.firstPriceAvailable;
  const comparedPrice = button.dataset.firstComparedPrice;
  const variants = JSON.parse(button.dataset.variants);

  console.log("Clicked Upsell:", title);

  // Create a dropdown if variants exist
  let variantsDropdown = "";
  if (variants && variants.length > 0) {
    console.log("VARIANTS ", variants);
    variantsDropdown = `<select id="upsellVariantSelect">`;
    variants.forEach((variant) => {
      const variantImage =
        variant.featured_image && variant.featured_image.src
          ? variant.featured_image.src
          : imageUrl;
      variantTitle = variant.title;
      variantsDropdown += `
        <option value="${variant.id}"
        data-image-url="${variantImage}" 
        data-price="${variant.price}" 
        data-compared-price="${variant.compare_at_price}" 
        data-variant-title="${variant.title}">
        ${variant.title}
        </option>`;
    });
    variantsDropdown += `</select>`;
  }

  // Modal HTML Content
  const modalContent = `
    <div class="MyCartUpsells_ModalOverlay">
      <div class="MyCartUpsells_Modal">
        <button class="MyCartUpsells_CloseModal">&times;</button>
        <div class="MyCartUpsells_Content">
          <img src="${imageUrl}" alt="${title}" class="MyCartUpsells_Image">
          <div class="MyCartUpsells_product-details">
            <h2 class="MyCartUpsells_title">${title}</h2>
            <div class="MyCartUpsells_price MyCartUpsells_sale-price">
              <span id="upsellPrice">${firstPrice}</span>
              ${
                comparedPrice
                  ? `<span class="MyCartUpsells_ComparePrice">${comparedPrice}</span>`
                  : ""
              }
            </div>
            ${variantTitle != "Default Title" ? `${variantsDropdown}` : ``}
            <button class="MyCartUpsells_AddToCart" data-variant-id="${
              variants[0].id
            }">Įdėti į krepšelį</button>
          </div> 
          
        </div>
      </div>
    </div>`;

  // Insert modal into the DOM
  document.body.insertAdjacentHTML("beforeend", modalContent);

  // Event listener for variant change
  const variantSelect = document.getElementById("upsellVariantSelect");

  if (variantSelect) {
    variantSelect.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];
      const newImage = selectedOption.dataset.imageUrl;
      const newPrice = selectedOption.dataset.price;
      const newComparedPrice = selectedOption.dataset.comparedPrice;

      const formatNewPrice = formatToGermanMoney(newPrice);
      const formatComparedPrice = formatToGermanMoney(newComparedPrice);

      document.querySelector(".MyCartUpsells_Image").src = newImage;
      document.getElementById("upsellPrice").textContent = formatNewPrice;
      document.querySelector(".MyCartUpsells_ComparePrice").textContent =
        formatComparedPrice;
    });
  }
}

// Function to Close Modal
function closeUpsellModal() {
  const modal = document.querySelector(".MyCartUpsells_ModalOverlay");
  if (modal) {
    modal.remove();
  }
}

// Function to Add Product to Cart
function addUpsellToCart() {
  const variantSelect = document.getElementById("upsellVariantSelect");
  const variantId = variantSelect
    ? variantSelect.value
    : document.querySelector(".MyCartUpsells_AddToCart").dataset.variantId;
  liquidAjaxCart.add({
    id: variantId,
    quantity: 1,
  });

  closeUpsellModal();
}
/*****************************************************************************************/

function showSpinner(key) {
  const wrapper = document.querySelector(`[data-price-wrapper="${key}"]`);
  if (wrapper) wrapper.classList.add("loading");

  const subtotalWrapper = document.getElementById("cart-subtotal-wrapper");
  const discountWrapper = document.getElementById("cart-discount-wrapper");
  // if (subtotalWrapper) subtotalWrapper.classList.add("loading");
  // if (discountWrapper) discountWrapper.classList.add("loading");
}

function hideSpinner(key) {
  const wrapper = document.querySelector(`[data-price-wrapper="${key}"]`);
  if (wrapper) wrapper.classList.remove("loading");

  const subtotalWrapper = document.getElementById("cart-subtotal-wrapper");
  const discountWrapper = document.getElementById("cart-discount-wrapper");
  // if (subtotalWrapper) subtotalWrapper.classList.remove("loading");
  // if (discountWrapper) discountWrapper.classList.remove("loading");
}

function optimisticPriceUpdate(lineKey, quantity) {
  const input = document.querySelector(`input[data-line-key="${lineKey}"]`);
  if (input) input.value = quantity;

  const wrapper = document.querySelector(`[data-price-wrapper="${lineKey}"]`);
  if (!wrapper) return;

  const unitPrice = parseInt(wrapper.dataset.unitPrice || 0);
  const comparePrice = parseInt(wrapper.dataset.comparePrice || 0);
  const newFinal = unitPrice * quantity;
  const newCompare = comparePrice * quantity;

  let html = `<div class="item-price item-sale-price">${formatToGermanMoney(
    newFinal
  )}</div>`;
  if (comparePrice && newCompare > newFinal) {
    html += `<div class="item-regular-price" style="text-decoration: line-through">${formatToGermanMoney(
      newCompare
    )}</div>`;
  }

  wrapper.innerHTML = html;
}

function optimisticSubtotalUpdate() {
  const inputs = document.querySelectorAll(".ajax-cart-quantity");
  let subtotal = 0;
  let compareTotal = 0;

  inputs.forEach((input) => {
    const qty = parseInt(input.value);
    const unitPrice = parseInt(input.dataset.unitPrice);
    const comparePrice = parseInt(input.dataset.comparePrice || unitPrice);
    const isFree =
      input.closest(".cart-drawer-items")?.dataset?.autoadded === "Yes";

    if (!isNaN(qty) && !isFree) {
      subtotal += qty * unitPrice;
      compareTotal += qty * comparePrice;
    }
  });

  const subtotalElem = document.getElementById("cart-subtotal");
  const discountElem = document.getElementById("cart-discount");

  if (subtotalElem) subtotalElem.textContent = formatToGermanMoney(subtotal);
  if (discountElem) {
    const discount = Math.max(compareTotal - subtotal, 0);
    discountElem.textContent = formatToGermanMoney(discount);
  }
}

function updateCartQuantity(lineKey, quantity) {
  optimisticPriceUpdate(lineKey, quantity);
  optimisticSubtotalUpdate();

  showSpinner(lineKey);

  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: lineKey, quantity: quantity }),
  })
    .then(() => fetch("/cart.js"))
    .then((res) => res.json())
    .then((cart) => {
      cart.items.forEach((item) => {
        const wrapper = document.querySelector(
          `[data-price-wrapper="${item.key}"]`
        );
        const input = document.querySelector(
          `input[data-line-key="${item.key}"]`
        );

        if (wrapper) {
          let priceHTML = `<div class="item-price item-sale-price">${formatToGermanMoney(
            item.final_line_price
          )}</div>`;
          if (item.variant.compare_at_price > item.final_price) {
            priceHTML += `<div class="item-regular-price" style="text-decoration: line-through">${formatToGermanMoney(
              item.variant.compare_at_price * item.quantity
            )}</div>`;
          }
          wrapper.innerHTML = priceHTML;
        }

        if (input) input.value = item.quantity;
        hideSpinner(item.key);
      });
      // updateSubtotalAndDiscount(cart);
      optimisticSubtotalUpdate();
    })
    .catch((err) => {
      console.error("Cart update error:", err);
      hideSpinner(lineKey);
    });
}

document.addEventListener("click", function (e) {
  const plusBtn = e.target.closest(".ajax-cart-plus");
  const minusBtn = e.target.closest(".ajax-cart-minus");

  if (plusBtn) {
    const key = plusBtn.dataset.lineKey;
    const input = document.querySelector(`input[data-line-key="${key}"]`);
    const qty = parseInt(input.value);
    updateCartQuantity(key, qty + 1);
  }

  if (minusBtn) {
    const key = minusBtn.dataset.lineKey;
    const input = document.querySelector(`input[data-line-key="${key}"]`);
    const qty = parseInt(input.value);
    if (qty > 1) updateCartQuantity(key, qty - 1);
  }
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".ajax-cart-quantity")) {
    const key = e.target.dataset.lineKey;
    const qty = parseInt(e.target.value);
    if (!isNaN(qty) && qty >= 0) updateCartQuantity(key, qty);
  }
});
